import { enCA, frCA } from 'date-fns/locale';
import { formatDistance } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';
import { CalculationStatusEnum } from '../../../../../../../common/src/enums/calculations/calculation-status.enum';
import { CalculationKeynameEnum } from '../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { CalculationResponse } from '../../../../../../../common/dist/angular/responses/calculation.response';
import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidationError } from '@pristine-ts/class-validator';
import { CalculationIndexModel } from '../../../../../../../common/src/index-models/calculation.index-model';


@Injectable()
export class CalculationsUtils {
  constructor(private readonly translateService: TranslateService) {
  }

  getCalculationKeynameText(calculationKeyname: CalculationKeynameEnum): string {
    switch (calculationKeyname) {
      case CalculationKeynameEnum.Section84_1:
        return 'Vente d\'actions (application de 84.1 LIR)';
      case CalculationKeynameEnum.Rollover:
        return 'Roulement';
      case CalculationKeynameEnum.RRQ:
        return 'RRQ';
      case CalculationKeynameEnum.SalaryDividendSimulation:
        return 'Salaire Dividende';
      case CalculationKeynameEnum.RrspSimulation:
        return 'Reer';
    }
    return 'Défault';
  }

  getStatusText(calculationStatusEnum: CalculationStatusEnum): string {
    switch (calculationStatusEnum) {
      case CalculationStatusEnum.InProgress:
        return 'En cours d\'exécution';

      case CalculationStatusEnum.Created:
        return 'Brouillon';

      case CalculationStatusEnum.Completed:
        return 'Terminé';

      case CalculationStatusEnum.Error:
        return 'Erreurs';
    }

    return 'En cours de chargement...';
  }

  getUpdatedAtSortedArray(calculationResponse: CalculationResponse | CalculationIndexModel): Date[] {
    let updatedAtArray = [
      calculationResponse.updatedAt,
    ];

    updatedAtArray = updatedAtArray.sort((a, b) => {
      return b.getTime() - a.getTime();
    });

    return updatedAtArray;
  }

  getLastModifiedDate(calculationResponse: CalculationResponse | CalculationIndexModel): Date | undefined {
    return this.getUpdatedAtSortedArray(calculationResponse)[0];
  }

  getLastModifiedText(lastModified: Date) {
    if (lastModified === undefined) {
      return 'En cours de chargement...'; // todo: translation
    }

    let locale = enCA;

    if (this.translateService.currentLang.startsWith('fr')) {
      locale = frCA;
    }

    return formatDistance(lastModified, Date.now(), {
      locale,
      addSuffix: true,
    });
  }

  getErrors(validationErrors: ValidationErrors[], parentPath: string = ''): {
    property: string,
    messages: string[],
    value: any
  }[] {
    const errors: { property: string, messages: string[], value: any }[] = [];

    validationErrors.forEach((validationError: ValidationError) => {
      const messages: string[] = [];
      for (const constraintsKey in validationError.constraints) {
        messages.push(validationError.constraints[constraintsKey].message);
      }

      errors.push({
        messages,
        property: `${parentPath}${validationError.property}`,
        value: validationError.value,
      });

      errors.push(...this.getErrors(validationError.children, `${parentPath}${validationError.property}.`));
    });

    return errors;
  }
}
